export const catalogListLanguage = {
    en: {
        AddCatalog: 'Add Catalog',
        CatalogID: 'Catalog ID',
        CatalogLogo: 'Catalog Logo',
        CatalogName: 'Catalog Name',
        Language: 'Language',
        Status: 'Status',
        Action: 'Action',
        CatalogList: 'Catalog List',
        'status.inactive': 'Inactive',
        'status.active': 'Active',
    },
    th: {
        AddCatalog: 'เพิ่มแคตตาล็อก',
        CatalogID: 'รหัสแคตตาล็อก',
        CatalogLogo: 'โลโก้แคตตาล็อก',
        CatalogName: 'ชื่อแคตตาล็อก',
        Language: 'ภาษา',
        Status: 'สถานะ',
        Action: 'การดำเนินการ',
        CatalogList: 'รายการแคตตาล็อก',
        'status.inactive': 'ไม่ใช้งาน',
        'status.active': 'ใช้งาน',
    },
    jp: {
        AddCatalog: 'カタログを追加',
        CatalogID: 'カタログID',
        CatalogLogo: 'カタログロゴ',
        CatalogName: 'カタログ名',
        Language: '言語',
        Status: 'ステータス',
        Action: 'アクション',
        CatalogList: 'カタログリスト',
        'status.inactive': '非活性',
        'status.active': '活性',
    },
    cn: {
        AddCatalog: '添加目录',
        CatalogID: '目录ID',
        CatalogLogo: '目录标志',
        CatalogName: '目录名称',
        Language: '语言',
        Status: '状态',
        Action: '操作',
        CatalogList: '目录列表',
        'status.inactive': '非活跃',
        'status.active': '活跃',
    },
    kr: {
        AddCatalog: '카탈로그 추가',
        CatalogID: '카탈로그 ID',
        CatalogLogo: '카탈로그 로고',
        CatalogName: '카탈로그 이름',
        Language: '언어',
        Status: '상태',
        Action: '작업',
        CatalogList: '카탈로그 목록',
        'status.inactive': '비활성',
        'status.active': '활성',
    },
}

export const catalogAddLanguage = {
    en: {
        CatalogID: 'Catalog ID',
        CatalogName: 'Catalog Name',
        CurrentCatalogImage: 'Current Catalog Image',
        UploadPageImage: 'Upload Catalog Image',
        AlternativeLanguages: 'Alternative Languages',
        Thai: 'Thai',
        English: 'English',
        Chinese: 'Chinese',
        Status: 'Status',
        Submit: 'Submit',
        Cancel: 'Cancel',
        AddEditCatalog: 'Add/Edit Catalog',
        'status.active': 'Active',
        'status.inactive': 'Inactive',
        'Catalog submitted successfully': 'Catalog submitted successfully',
        'Failed to submit catalog:': 'Failed to submit catalog:',
        'Failed to submit catalog. Please try again later.': 'Failed to submit catalog. Please try again later.',
    },
    th: {
        CatalogID: 'รหัสแคตตาล็อก',
        CatalogName: 'ชื่อแคตตาล็อก',
        CurrentCatalogImage: 'รูปภาพแคตตาล็อกปัจจุบัน',
        UploadPageImage: 'อัปโหลดรูปภาพแคตตาล็อก',
        AlternativeLanguages: 'ภาษาเพิ่มเติม',
        Thai: 'ไทย',
        English: 'อังกฤษ',
        Chinese: 'จีน',
        Status: 'สถานะ',
        Submit: 'บันทึก',
        Cancel: 'ยกเลิก',
        AddEditCatalog: 'เพิ่ม/แก้ไขแคตตาล็อก',
        'status.active': 'ใช้งาน',
        'status.inactive': 'ไม่ใช้งาน',
        'Catalog submitted successfully': 'ส่งแคตตาล็อกสำเร็จ',
        'Failed to submit catalog:': 'ส่งแคตตาล็อกไม่สำเร็จ:',
        'Failed to submit catalog. Please try again later.': 'ส่งแคตตาล็อกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    },
    jp: {
        CatalogID: 'カタログID',
        CatalogName: 'カタログ名',
        CurrentCatalogImage: '現在のカタログ画像',
        UploadPageImage: 'カタログ画像をアップロード',
        AlternativeLanguages: '他の言語',
        Thai: 'タイ語',
        English: '英語',
        Chinese: '中国語',
        Status: 'ステータス',
        Submit: '送信',
        Cancel: 'キャンセル',
        AddEditCatalog: 'カタログの追加/編集',
        'status.active': '有効',
        'status.inactive': '無効',
        'Catalog submitted successfully': 'カタログが正常に送信されました',
        'Failed to submit catalog:': 'カタログの送信に失敗しました:',
        'Failed to submit catalog. Please try again later.': 'カタログの送信に失敗しました。後でもう一度お試しください。',
    },
    cn: {
        CatalogID: '目录ID',
        CatalogName: '目录名称',
        CurrentCatalogImage: '当前目录图片',
        UploadPageImage: '上传目录图片',
        AlternativeLanguages: '其他语言',
        Thai: '泰语',
        English: '英语',
        Chinese: '中文',
        Status: '状态',
        Submit: '提交',
        Cancel: '取消',
        AddEditCatalog: '添加/编辑目录',
        'status.active': '启用',
        'status.inactive': '禁用',
        'Catalog submitted successfully': '目录提交成功',
        'Failed to submit catalog:': '目录提交失败：',
        'Failed to submit catalog. Please try again later.': '目录提交失败，请稍后再试。',
    },
    kr: {
        CatalogID: '카탈로그 ID',
        CatalogName: '카탈로그 이름',
        CurrentCatalogImage: '현재 카탈로그 이미지',
        UploadPageImage: '카탈로그 이미지 업로드',
        AlternativeLanguages: '추가 언어',
        Thai: '태국어',
        English: '영어',
        Chinese: '중국어',
        Status: '상태',
        Submit: '제출',
        Cancel: '취소',
        AddEditCatalog: '카탈로그 추가/편집',
        'status.active': '활성',
        'status.inactive': '비활성',
        'Catalog submitted successfully': '카탈로그가 성공적으로 제출되었습니다',
        'Failed to submit catalog:': '카탈로그 제출 실패:',
        'Failed to submit catalog. Please try again later.': '카탈로그 제출에 실패했습니다. 나중에 다시 시도하세요.',
    },
}